import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { ILookupOptions } from "devextreme-react/lookup";
import { forwardRef, useCallback, useEffect,  useState } from "react";
import { useSelector } from "react-redux";
import { getApiParams } from "../../../../../redux/auth";
import { BodyType, createRequest } from "../../../../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../../../../redux/base/types/saga";
import { getLocalized } from "../../../../../redux/localization";
import { AdminAccountLocation, City, Country, CreateStorage, District, Neighbourhood, SubDistrict } from "./type";

export const CreateAccountStorageForm = forwardRef<any, { data: CreateStorage, data1: AdminAccountLocation }>((
    { data, data1 }, ref
) => {
    const localize = useSelector(getLocalized);
    const [countries, setCountries] = useState<Country[]>([]);
    const [cities, setCities] = useState<City[]>([])
    const [districts, setDistricts] = useState<District[]>([]);
    const [subDistricts, setSubDistricts] = useState<SubDistrict[]>([]);
    const [neighbourhoods, setNeightbourHoods] = useState<Neighbourhood[]>([]);
    const { token, lang } = useSelector(getApiParams);

    const getCountries = useCallback((async () => {
        const response: ApiResponse<Country[]> = await createRequest({
            method: "GET",
            url: "/api/system/countries",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setCountries(response.Result)
        }
    }), [token, lang])

    const getCities = useCallback((async (Id: any) => {
        const response: ApiResponse<City[]> = await createRequest({
            method: "GET",
            url: "/api/system/cities",
            bodyType: BodyType.raw,
            token,
            body: Id,
            lang,
        });
        if (verfiyResponse(response)) {
            setCities(response.Result)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [token, lang])

    const getDistricts = useCallback((async (CityId: any) => {
        const response: ApiResponse<District[]> = await createRequest({
            method: "GET",
            url: "/api/system/districts",
            bodyType: BodyType.raw,
            token,
            body: { CityId },
            lang,
        });
        if (verfiyResponse(response)) {
            setDistricts(response.Result)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [token, lang])
    const getSubDistricts = useCallback((async (DistrictId: any) => {
        const response: ApiResponse<SubDistrict[]> = await createRequest({
            method: "GET",
            url: "/api/system/subdistricts",
            bodyType: BodyType.raw,
            token,
            body: { DistrictId },
            lang,
        });
        if (verfiyResponse(response)) {
            setSubDistricts(response.Result)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [token, lang])

    const getNeighbourhoods = useCallback((async (SubDistrictId: any) => {
        const response: ApiResponse<Neighbourhood[]> = await createRequest({
            method: "GET",
            url: "/api/system/neighbourhoods",
            bodyType: BodyType.raw,
            token,
            body: { SubDistrictId },
            lang,
        });
        if (verfiyResponse(response)) {
            setNeightbourHoods(response.Result)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [token, lang])


    useEffect(() => {
        getCountries();

    }, [getCountries])
    return <>
        <Form
            formData={data1}
            
        >
            <GroupItem colCount={2}>
                <SimpleItem
                    dataField={"Country"}
                    label={{
                        text: localize.getString("country"),
                    }}
                    editorType={"dxLookup"}
                    editorOptions={
                        {
                            searchEnabled: true,
                            items: countries,
                            displayExpr: "CountryName",
                            valueExpr: "Id",
                            placeholder: "Ülke",
                            onValueChanged: (e: any) => {
                                getCities(e.value)
                            }
                        } as ILookupOptions
                    }
                >
                </SimpleItem>
                <SimpleItem
                    dataField={"City"}
                    label={{
                        text: localize.getString("city"),
                    }}
                    editorType={"dxLookup"}
                    editorOptions={
                        {
                            
                            searchEnabled: true,
                            items: cities,
                            displayExpr: "CityName",
                            valueExpr: "Id",
                            placeholder: "Şehir",
                            onValueChanged: (e: any) => { getDistricts(e.value) }
                        } as ILookupOptions
                    }
                >
                </SimpleItem>
                <SimpleItem
                    dataField={"District"}
                    label={{
                        text: localize.getString("district"),
                    }}
                    editorType={"dxLookup"}
                    editorOptions={
                        {
                            searchEnabled: true,
                            items: districts,
                            displayExpr: "DistrictName",
                            valueExpr: "Id",
                            placeholder: "İlçe",
                            onValueChanged: (e: any) => { getSubDistricts(e.value) }
                        } as ILookupOptions
                    }
                >
                </SimpleItem>
                <SimpleItem
                    dataField={"Subdistrict"}
                    label={{
                        text: localize.getString("subdistrict"),
                    }}
                    editorType={"dxLookup"}
                    editorOptions={
                        {
                            searchEnabled: true,
                            items: subDistricts,
                            displayExpr: "SubDistrictName",
                            valueExpr: "Id",
                            placeholder: "Semt",
                            onValueChanged: (e: any) => { getNeighbourhoods(e.value) }
                        } as ILookupOptions
                    }
                >
                </SimpleItem>
            </GroupItem>
        </Form>
        <Form
            formData={data}
            ref={ref}
        >
            <GroupItem colCount={2}>

                <SimpleItem
                    dataField={"neighbourhoodId"}
                    label={{
                        text: localize.getString("neighbourhood"),
                    }}
                    editorType={"dxLookup"}
                    editorOptions={
                        {
                            searchEnabled: true,
                            items: neighbourhoods,
                            displayExpr: "NeighbourhoodName",
                            valueExpr: "Id",
                            placeholder: "Mahalle",

                        } as ILookupOptions
                    }
                >
                </SimpleItem>
                <SimpleItem
                    dataField={"locationTitle"}
                    editorType={"dxTextBox"}

                    label={{ text: localize.getString("locationtitle") }}
                >


                </SimpleItem>
                <SimpleItem
                    dataField={"addressDetail"}
                    editorType={"dxTextBox"}

                    label={{ text: localize.getString("addressDetail") }}
                >


                </SimpleItem>
            </GroupItem>
        </Form>

    </>
})